import { TransactionContext } from "@sentry/types";
import { matchPath } from "react-router-dom";

import { routesConfig } from "./routesConfig";

const samplingPerFeature = {
  classroom: 0.0001,
  dashboard: 0.0001,
  teacher: 0.001,
  parent: 0.03
};

function shouldSampleByFeature(path: string) {
  const random = Math.random();

  if (path.match("/classroom")) {
    return samplingPerFeature.classroom > random;
  }
  if (path.match("/dashboard")) {
    return samplingPerFeature.dashboard > random;
  }
  if (path.match("/teacher")) {
    return samplingPerFeature.teacher > random;
  }
  if (path.match("/parent")) {
    return samplingPerFeature.parent > random;
  }
  return false;
}

function shouldSampleByRoute(path: string) {
  const shouldSampleRoute = routesConfig.some(route => {
    return matchPath(path, {
      path: route.path,
      exact: true
    });
  });

  return shouldSampleRoute;
}

export function customTracesSampler(context: TransactionContext) {
  const currentPath = context.name;

  return shouldSampleByRoute(currentPath) && shouldSampleByFeature(currentPath);
}
